<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >

    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span class="mr-1"> تعداد :</span>
              <span class="mr-1">{{ totalCounts }}</span>
              <span>نفر</span>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perState"
                  :options="perStateOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
              <label>وضعیت</label>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="4"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="debouncedSearch"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-md-0"
            >
              <b-button
                  variant="success"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadFile"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="students"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی یافت نشد."
        >

          <template #cell(user.name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="`https://api.rahazarei.com/media/gallery/profile/${data.item.user.selfieFileData}`"
                    :variant="`success`"
                    :to="{ name: 'apps-users-edit', params: { id: data.item.user.userId } }"
                />
              </template>
              <b-link
                  :to="{ name: 'apps-users-edit', params: { id: data.item.user.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.user.name + ' ' + data.item.user.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.user.userId }}</small>
            </b-media>
          </template>

          <!-- Column: type -->
          <template #cell(type)="data">
            <b-badge
                pill
                class="text-capitalize"
                :variant="``"
            >
              {{ data.item.type }}
            </b-badge>
          </template>


          <!-- Column: followState -->
          <template #cell(followState)="data">
            <span v-if="data.item.followState === null">-</span>
            <b-badge
                v-if="data.item.followState === 1"
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              وارد شده
            </b-badge>
            <b-badge
                v-else-if="data.item.followState === 2"
                pill
                class="text-capitalize"
                :variant="`warning`"
            >
              فالو نکرده
            </b-badge>
            <b-badge
                v-else-if="data.item.followState === 3"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              آیدی اشتباه
            </b-badge>

            <b-dropdown
                variant="link"
                no-caret
            >
              <template #button-content>
                <feather-icon
                    icon="ChevronDownIcon"
                    size="16"
                    class="align-middle text-body"
                />
              </template>

              <b-dropdown-item @click="setState(data.item.user.userId,1)">
                <span class="align-middle ml-50">وارد شده</span>
              </b-dropdown-item>

              <b-dropdown-item @click="setState(data.item.user.userId,2)">
                <span class="align-middle ml-50">فالو نکرده</span>
              </b-dropdown-item>

              <b-dropdown-item @click="setState(data.item.user.userId,3)">
                <span class="align-middle ml-50">آیدی اشتباه</span>
              </b-dropdown-item>

            </b-dropdown>
          </template>

          <!-- Column: chat -->
          <template #cell(chat)="data">
            <b-link :to="{ name: 'apps-chats-id', params: { id: data.item.user.userId } }">
              <feather-icon icon="MessageCircleIcon" size="20"/>
            </b-link>
          </template>

          <!-- Column: state -->
          <template #cell(order.isPayed)="data">
            <b-badge
                v-if="data.item.order.isPayed === true"
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              پرداخت شده
            </b-badge>
            <b-badge
                v-else-if="data.item.order.isPayed === false"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              پرداخت نشده
            </b-badge>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <QueriedPagination v-if="totalCounts" v-model="currentPage" :total-counts="totalCounts"
                                 :per-page="perPage"/>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {OrderGetAllRequest, OrderGetRegisteredUserRequestV3} from "@/libs/Api/Order";
import Helper from "@/libs/Helper";
import {OrderGetRegisteredUserRequest} from "@/libs/Api/Order";
import {ProductSetFollowStateRequest} from "@/libs/Api/Product";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import {getUserData} from "@/auth/utils";
import QueriedPagination from "@/views/components/QueriedPagination.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "StudentInfoes",
  title: "لیست دانشجویان - پنل ادمین رها مزون",
  data() {
    return {
      students: [],
      showOverlay: false,
      productId: this.$route.params.id,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      perPageOptions: [10, 20, 30, 40, 50],
      timeOut: null,
      myTableColumns: [
        {key: 'user.name', label: 'نام کامل'},
        {key: 'user.nationalId', label: 'کد ملی'},
        {key: 'user.mobile', label: 'موبایل'},
        {key: 'user.instagramId', label: 'اینستاگرام'},
        {key: 'followState', label: 'وضعیت کاربر'},
        // { key: 'buy',label:'ثبت سفارش'},
        // {key: 'chat', label: 'چت'},
        // {key: 'order.isPayed', label: 'وضعیت سفارش'},
      ],
      searchCommand: '',
      isAddNewUserSidebarActive: false,
      perState: '',
      perStateOptions: [
        {label: 'همه', value: ''},
        {label: 'وارد شده', value: 1},
        {label: 'فالو نکرده', value: 2},
        {label: 'آیدی اشتباه', value: 3}
      ],
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getStudents()
  },
  methods: {
    async getStudents() {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        pageNumber: _this.$route.query.pageNumber ? _this.$route.query.pageNumber : _this.currentPage,
        count: _this.perPage,
        productId: _this.productId,
        searchCommand: _this.searchCommand,
        state: _this.perState,
      }

      let orderGetRegisteredUserRequest = new OrderGetRegisteredUserRequestV3(_this);
      orderGetRegisteredUserRequest.setParams(data);
      await orderGetRegisteredUserRequest.fetch(function (content) {
        _this.students = content.result;
        _this.totalCounts = content.ordersCount;
        _this.showOverlay = false;
      }, function (error) {
        console.log(error);
        _this.showOverlay = false;
      })
    },
    async setState(userId, state) {
      let _this = this;
      _this.showOverlay = true;
      let data = {
        userId: userId,
        productId: _this.productId,
        state: state
      }

      let productSetFollowStateRequest = new ProductSetFollowStateRequest(_this);
      productSetFollowStateRequest.setParams(data);
      await productSetFollowStateRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.getStudents();
      }, function (error) {
        console.log(error);
        _this.showOverlay = false;
      })
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;
      await axiosIns.post('Order/GetRegisteredUserExcelV3', null, {
        params: {
          pageNumber: _this.$route.query.pageNumber ? _this.$route.query.pageNumber : _this.currentPage,
          count: _this.perPage,
          searchCommand: _this.searchCommand,
          productId: _this.productId,
          state: _this.perState,
        },
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست دانشجویان.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getStudents();
    },
    currentPage: function (nv, ov) {
      this.getStudents();
    },
    searchCommand: function (nv, ov) {
      this.getStudents();
    },
    perState: function (nv, ov) {
      this.getStudents();
    }
  },
  computed: {
    debouncedSearch: {
      get() {
        return this.searchCommand
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          this.searchCommand = val
        }, 600)
      }
    }
  },
  components: {
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
